﻿angular.module('taric.texts', [])
    .component('annotationButton', require('./components/annotation-button'))
    .component('annotation', require('./components/annotation'))
    .component('annotationNavItem', require('./components/annotation-nav-item'))
    .component('cccConclusion', require('./components/ccc-conclusion'))
    .component('chapterNotesButton', require('./components/chapter-notes-button'))
    .component('explanatoryNoteButton', require('./components/explanatory-note-button'))
    .component('noteSource', require('./components/note-source'))
    .component('scheduleBChapterNotesButton', require('./components/schedule-b-chapter-notes-button'))
    .component('scheduleBSectionNotesButton', require('./components/schedule-b-section-notes-button'))
    .component('sectionNotesButton', require('./components/section-notes-button'))
    .component('subchapterNotesButton', require('./components/subchapter-notes-button'))
    .component('wcoClassificationOpinion', require('./components/wco-classification-opinion'))
    .factory('textDataService', require('./services/text-data'))
    .factory('annotationsDataService', require('./services/annotations-data'))
    .factory('annotationsNavigationService', require('./services/annotations-navigation'))
    .factory('annotationsModal', require('./modals/annotations'))
    .factory('explanatoryNoteModal', require('./modals/explanatory-note'))
    .factory('pdfViewerModal', require('./modals/pdf-viewer'))
;